"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachPebble = function SvgBeachPebble(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 34"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.572 29.901c-5.395.073-10.327-.3-10.327-4.245 0-3.947 6.53-5.3 11.516-4.528 4.986.772 11.851 1.648 11.851 4.215 0 2.568-6.752 4.474-13.04 4.558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.814 20.488c-1.698-.498-3.084-1.013-3.084-3.066s4.93-3.452 9.86-3.452 10.384.762 10.384 3.369-3.92 3.926-10.045 3.926c-2.177 0-4.468 0-7.115-.777z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.74 8.438c-.994.01-5.413.029-5.413 3.066s6.416 2.577 6.416 2.577 8.74-.225 8.74-2.73c0-2.506-7.553-2.935-9.744-2.913zm-.507-.08c-.926.009-3.35-.138-3.35-2.062s1.662-2.044 2.814-2.044c1.153 0 4.628.427 4.628 1.976 0 1.55-3.357 2.124-4.092 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.916 27.858c-2.19 2.815-7.326 1.873-7.326 1.873s-2.34-4.467-.433-9.679c1.907-5.212 9.731-7.658 13.944-4.12 4.212 3.536 3.85 8.85 2.812 10.802-1.037 1.953-4.635 3.381-7.779 2.002-3.143-1.378-2.953-6.557.39-7.62 3.343-1.064 4.496 2.055 3.672 3.368-.823 1.313-3.614 1.728-3.838.294-.224-1.433 1.223-2.232 2.027-1.263",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.843 26.432s-3.2 2.354-6.705 1.351m6.678-3.271s-4.605 1.661-7.097-2.483m7.921.331s-4.258-1.367-4.258-6.127m6.044 4.677s-1.907-2.69-.362-6.525m3.104 6.786s.278-3.21 3.14-3.661m-1.864 5.065s2.103-1.46 3.991 0M46.18 24.87s2.106.475 1.804 3.581m-5.364.546s2.032-.881 1.293-3.06"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBeachPebble);
var _default = exports["default"] = Memo;